import DialogProvider from "./dialog-provider";
import LocalizationProvider from "./localization-provider";
import QueryProvider from "./query-provider";
import AppRoutes from "./routes";
import StyleProvider from "./style-provider";
// ConfigurationProvider is wired under Auth in ContextLayout

export default function App() {
    return <LocalizationProvider>
        <StyleProvider>
            <DialogProvider>
                <QueryProvider>
                    <AppRoutes />
                </QueryProvider>
            </DialogProvider>
        </StyleProvider>
    </LocalizationProvider>
}